import { StyleSheet } from 'react-native'
import STYLES from '../../constants/styles'

export default StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFillObject
        , backgroundColor: STYLES.BACKGROUND_COLOR
        , justifyContent: 'center'
        , alignItems: 'center'
        , padding: 10
    },
    close: {
        position: 'absolute'
        , top: 10
        , right: 10
    },
    badge: {
        flexBasis: '40%'
        , justifyContent: 'center'
        , alignItems: 'center'
    },
    badgeView: {
        borderRadius: 70
    },
    badgeImg: {
        borderRadius: 70
        , borderWidth: 4
        , borderColor: '#ffffff'
        , width: 140
        , height: 140
    },
    badgeText: {
        fontSize: 24
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
        , marginTop: 20
    },
    street: {
        fontSize: 12
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    avatarEdit: {
        position: 'absolute'
        , height: 40
        , width: 140
        , borderColor: 'blue'
        , backgroundColor: 'rgba(255, 255, 255, 0.5)'
        , borderBottomLeftRadius: 22
        , borderBottomRightRadius: 22
        , justifyContent: 'center'
        , alignItems: 'center'
        , bottom: 0
    },
    switcher: {
        flex: 1
        , justifyContent: 'flex-end'
    },
    switcherBadge: {
        flexDirection: 'row'
        , justifyContent: 'center'
        , alignItems: 'center'
        , paddingVertical: 10
    },
    switcherBadgeView: {
        borderRadius: 10
        , marginRight: 15
    },
    switcherBadgeImg: {
        borderRadius: 10
        , borderWidth: 4
        , borderColor: 'white'
        , width: 40
        , height: 40
    },
    switcherBadgeText: {
        fontSize: 14
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    logoutView: {
        marginRight: 15
    },
    logoutImg: {
        width: 40
        , height: 40
    },
    version: {
        position: 'absolute'
        , bottom: 5
        , left: 5
    },
    versionText: {
        fontSize: 12
        , color: STYLES.SECONDARY_TEXT_COLOR
    }
})



// WEBPACK FOOTER //
// ./src/components/profile/styles.js